/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "../../../../../services/cookieService";
import { LpMetaProps } from "../../../../../types/LpMetaProps";

const LpFineDrivingBanMeta = ({ keyword }: LpMetaProps) => {
  const title = keyword + " | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Sie haben eine rote Ampel überfahren? Lassen Sie Ihren Bußgeldbescheid online prüfen! - Schnell, einfach und sicher!" />
      <meta name="keywords" content="Rote Ampel, Verkehrsrecht, Bußgeld, Bußgeldbescheid, Anhörungsbogen, geblitzt, Ordnungswidrigkeit, Fahrverbot" />
      <meta name="robots" content="noindex,nofollow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta
        property="og:description"
        content="Sie haben ein Fahrverbot bekommen? Lassen Sie Ihren Bußgeldbescheid online prüfen! - Schnell, einfach und sicher!"
      />
    </Helmet>
  );
};

export default LpFineDrivingBanMeta;
